module.exports = __webpack_public_path__ + "static/media/canadian-owned-dt-fr.c1ad58ed.jpg";